import(/* webpackMode: "eager" */ "/vercel/path0/src/app/tr/blog/botoksun-alerji-riski-gercek-tehlike-mi-yanlis-algi-mi/page.tsx");
